export enum RegulationDetailType {
    Unknown,
    Regulation,
    Rulebook
}
